import React, { useState } from 'react';
import {
    RingProgress,
    Text,
    SimpleGrid,
    Paper,
    Center,
    Group,
    createStyles,
} from '@mantine/core';
import { IconArrowUpRight, IconArrowDownRight } from '@tabler/icons';
import { Carousel } from '@mantine/carousel';
import { 
    nanoid,
    unwrapResult,
} from '@reduxjs/toolkit';

const icons = {
  up: IconArrowUpRight,
  down: IconArrowDownRight,
};


const useStyles = createStyles((theme) => ({
    carouselContain: {
        maxWidth: '800px'
    }
}));


//of_note:entirely for demo purposes
//export function DashboardStats(data) {
export const DashboardStats = ({data}) => {
    const { classes, theme } = useStyles();
    
    const stats = data.map((stat) => {
    const Icon = icons[stat.icon];
    return (
         <Carousel.Slide key={nanoid()} >
            <Paper withBorder radius="md" p="xs" key={stat.label}>
                <Group>
                    <RingProgress
                        size={80}
                        roundCaps
                        thickness={8}
                        sections={[{ value: stat.progress, color: stat.color }]}
                        label={
                            <Center>
                                <Icon size="1.4rem" stroke={1.5} />
                            </Center>
                        }
                    />
                    <div>
                        <Text color="dimmed" size="xs" transform="uppercase" weight={700}>
                            {stat.label}
                        </Text>
                        <Text weight={700} size="xl">
                            {stat.stats}
                        </Text>
                    </div>
                </Group>
            </Paper>
        </Carousel.Slide>
    );
  });

  return (
    <Carousel slideSize="70%" height={200} align="start" slideGap="md" loop={true} withControls={false}>
        {stats}
    </Carousel>
  );
}
